var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSelectivityCardDark = function SvgSelectivityCardDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 700 301"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#selectivity_card_dark_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 700,
    height: 301,
    fill: "#1F1F1F",
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__b)",
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M348.933 235.534c64.718-36.45 194.33-135.532 226.495-156.878 15.674 2.366 29.61 130.154 55.595 177.019-12.065 47.752-81.247 38.106-111.564 30.581-30.318-7.526-182.59-2.97-170.526-50.722"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__c)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.195,
    cy: 20.971,
    fill: "#fff",
    rx: 22.195,
    ry: 20.971,
    transform: "matrix(-.97055 -.2409 .24496 -.96953 582.943 115.379)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__d)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.558,
    cy: 16.439,
    fill: "#fff",
    rx: 16.558,
    ry: 16.439,
    transform: "matrix(-.97055 -.2409 .24496 -.96953 576.772 106.934)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.181,
    cy: 15.072,
    fill: "#fff",
    rx: 15.181,
    ry: 15.072,
    transform: "matrix(-.97055 -.2409 .24496 -.96953 575.958 106.984)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M559.291 95.413c-.103-.128-.247-.346 0-.192.308.192.539 1.001 1.578.192s.963-.886 1.81-.886 1.617.694 1.809.694c.193 0 1.463-.193 1.502.192s.192.886.462 1.117c.215.185.526.283.654.308l.423.81-.885.692-1.001.617c-.064-.026-.447-.023-1.463.192-1.016.216-2.502.244-3.118.231l-1.155-.23-2.31-.193a11 11 0 0 0-.924-1.31c-.462-.54-.385-.115-.693-.809-.246-.554.693-1.18 1.193-1.425-.012-.09.054-.215.424 0 .462.27.654.231.924.347.215.092.603.038.77 0z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__f)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M559.576 98.495c.047.25.091.663-.109.313-.249-.438-.061-1.847-1.726-.95-1.665.896-1.619 1.053-2.604.71-.985-.341-1.489-1.78-1.713-1.858s-1.81-.277-1.637-.92c.173-.642.276-1.519.093-2.004a1.8 1.8 0 0 0-.587-.765l-.036-1.487 1.421-.771 1.512-.6c.06.069.506.219 1.81.278 1.303.06 3.047.613 3.756.883l1.213.842 2.577 1.246c.034.48.149 1.653.335 2.504.233 1.064.383.343.349 1.596-.026 1.002-1.472 1.642-2.192 1.837-.036.152-.184.33-.492-.17-.385-.626-.631-.64-.879-.938-.198-.237-.68-.306-.895-.31z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M557.276 97.601c-.192-.102-.505-.29-.222-.22.355.086 1.385.911.906-.468-.478-1.378-.6-1.433-.233-1.802s1.498.09 1.581.005c.084-.083.414-.857.873-.433s1.101.93 1.483 1.077c.306.118.553.094.638.068l1.113.741.413 1.18.274 1.141c-.058-.001-.221.168-.414.858s-.805 1.369-1.087 1.623l-.766.239-1.223.785a30 30 0 0 0-1.905-1.096c-.82-.416-.3.035-1.23-.624-.744-.528-1.056-1.654-1.12-2.151-.108-.098-.224-.27.184-.185.51.107.549-.02.799-.006.2.012.306-.218.334-.335z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M550.893 89.056c-.109-.042-.285-.124-.114-.113.214.013.767.414.625-.4-.141-.815-.211-.835.063-1.11s.934-.119.996-.181c.062-.063.36-.59.6-.376.24.215.586.46.81.508a.7.7 0 0 0 .394-.032l.615.339.123.696.039.688c-.035.006-.158.132-.36.59s-.666.958-.873 1.15l-.511.24-.862.638a12 12 0 0 0-1.073-.47c-.468-.167-.193.057-.702-.25-.408-.247-.474-.921-.456-1.228-.057-.049-.11-.144.137-.138.309.009.349-.077.504-.096.125-.016.219-.174.25-.25z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M557.721 90.37c-.071-.028-.185-.08-.074-.074.138.009.496.269.405-.26-.092-.527-.137-.54.04-.719s.605-.076.646-.117c.04-.04.233-.382.389-.243.155.139.379.297.524.329a.44.44 0 0 0 .256-.02l.398.219.08.45.026.447c-.023.004-.103.085-.234.382-.13.297-.431.62-.566.746l-.331.155-.558.414a7 7 0 0 0-.696-.305c-.303-.108-.125.037-.455-.162-.264-.16-.307-.597-.295-.796-.037-.032-.071-.094.089-.09.2.006.226-.049.327-.062.08-.01.141-.112.161-.162z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__j)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M559.029 79.909c-.071-.028-.185-.08-.074-.074.138.009.497.269.405-.26-.091-.527-.137-.54.041-.719.177-.178.605-.076.645-.117.04-.04.233-.382.389-.243s.38.297.525.329a.44.44 0 0 0 .255-.02l.399.219.079.451.026.446c-.023.004-.103.085-.233.382-.131.297-.432.62-.566.746l-.331.155-.559.414a8 8 0 0 0-.695-.305c-.304-.108-.126.037-.456-.162-.264-.16-.306-.597-.295-.796-.037-.031-.071-.094.089-.09.2.006.226-.049.327-.062.08-.01.141-.112.161-.162z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__k)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M560.631 79.811c-.071-.027-.184-.08-.074-.074.139.01.497.269.405-.259s-.137-.54.041-.72c.178-.178.605-.076.645-.116s.234-.382.389-.243c.156.138.38.297.525.328a.44.44 0 0 0 .255-.02l.399.22.08.45.025.447c-.023.003-.102.085-.233.382-.131.296-.432.62-.566.745l-.331.156-.559.413a7 7 0 0 0-.695-.305c-.303-.108-.125.037-.455-.162-.264-.16-.307-.597-.295-.796-.037-.031-.072-.093.089-.089.2.006.225-.05.326-.062.081-.01.142-.113.162-.163z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__l)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M560.154 77.667c-.071-.028-.185-.08-.074-.074.138.008.496.269.405-.26-.092-.527-.137-.54.041-.719.177-.178.604-.076.645-.117.04-.04.233-.382.389-.243.155.139.379.297.525.329a.44.44 0 0 0 .255-.02l.399.219.079.45.026.447c-.023.004-.103.085-.233.382-.131.297-.432.62-.567.746l-.331.155-.558.414a7 7 0 0 0-.696-.305c-.303-.108-.125.037-.455-.163-.264-.16-.307-.596-.295-.795-.037-.032-.071-.094.089-.09.2.006.226-.05.327-.062.08-.01.141-.112.161-.162z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__m)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M562.714 91.615c0-.163.014-.435.068-.223.068.264-.116 1.233.626.434.741-.8.734-.9 1.106-.786s.466 1.02.551 1.045c.084.026.71-.028.592.424-.119.451-.228 1.052-.191 1.356.03.243.132.398.179.445l-.098.994-.633.686-.656.58c-.02-.038-.188-.086-.711.029s-1.185-.051-1.451-.148l-.426-.422-.947-.532c.023-.318.066-1.092.055-1.641-.013-.687-.128-.186-.019-1.03.086-.676.72-1.278 1.025-1.494.026-.105.1-.242.186.057.108.374.206.355.284.525.062.136.251.125.338.103z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__n)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M560.312 85.403c-.163-.18-.419-.495-.145-.315.342.224 1.098 1.48 1.158-.15s-.048-1.734.496-1.984 1.559.658 1.682.602c.124-.057.795-.747 1.109-.128.314.62.789 1.393 1.135 1.692.277.24.55.307.652.311l.879 1.2-.048 1.395-.179 1.304c-.061-.023-.304.094-.795.747-.49.652-1.423 1.137-1.828 1.297l-.915-.037-1.627.365c-.292-.374-1.016-1.273-1.577-1.87-.702-.747-.334-.076-1.052-1.12-.575-.835-.443-2.138-.305-2.684-.075-.144-.127-.37.272-.125.499.305.594.185.854.295.208.087.416-.115.494-.227z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__o)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M563.884 95.786c-.086-.098-.221-.27-.078-.17.179.124.583.806.593-.066s-.046-.93.231-1.056c.276-.127.809.371.872.343.063-.03.399-.39.568-.055s.423.756.605.92a.65.65 0 0 0 .339.175l.467.653-.007.747-.076.696c-.032-.013-.156.046-.4.39-.244.343-.717.59-.923.672l-.471-.032-.832.176a18 18 0 0 0-.834-1.022c-.37-.408-.173-.044-.555-.612-.306-.454-.254-1.15-.19-1.441-.041-.078-.07-.2.138-.064.261.17.308.107.443.169.108.05.212-.057.251-.116z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__p)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M568.182 80.155c-.066-.076-.171-.208-.061-.132.138.096.449.621.457-.05.008-.672-.035-.716.178-.813.212-.098.623.286.671.264.049-.023.308-.3.438-.042s.325.582.465.708a.5.5 0 0 0 .261.135l.36.502-.006.575-.058.536c-.025-.01-.12.036-.308.3s-.552.455-.711.518l-.362-.025-.641.136a14 14 0 0 0-.642-.787c-.285-.314-.133-.034-.427-.471-.236-.35-.196-.886-.146-1.11-.032-.06-.054-.153.106-.049.2.13.237.082.341.13.083.038.163-.043.193-.089z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__q)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M556.064 80.501c-.294-.187-.818.087-1.043.248-.179.129-.664.387-1.182.392-.648.006-1.355 1.392-1.884 3.49-.529 2.097-.61.957-1.09 2.768s-.426 1.003-.028 2.853.081 1.14 1.034 3.033c.953 1.892 1.243.61 1.836 1.455s1.163 1.463 2.205 1.453 1.658.696 3.417.489c1.759-.208 1.023-.533 1.439-.538.416-.004 1.476.366 4.192 1.623s1.982.694 4.162-.041c2.181-.735 1.292.32 2.821-.028s1.195.701 1.702.934.559-.48.588-3.382c.028-2.9.605-.433.946-2.196s-.077-1.616-.896-3.034c-.818-1.418-1.8-.315-2.618-1.828s-1.659-.554-2.437-1.355c-.779-.8-1.203.012-2.171-.264-.968-.275-1.469-1.079-1.325-1.603.143-.525-.639-.897-1.557-1.554-.919-.656-2.623-1.353-3.261-2.345s-1.938-.361-2.771-.353c-.832.008-1.711.017-2.079-.217"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__r)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M566.968 83.566c-.073-.084-.189-.231-.067-.146.153.106.499.69.508-.057.009-.746-.04-.795.197-.903.236-.109.693.318.746.293s.342-.334.487-.046c.145.286.362.646.517.787a.56.56 0 0 0 .29.15l.4.558-.006.64-.065.595c-.027-.011-.133.04-.342.334-.209.293-.614.505-.791.575l-.402-.027-.713.15c-.132-.175-.46-.594-.713-.874-.317-.35-.148-.038-.475-.524-.262-.39-.217-.984-.162-1.234-.035-.066-.06-.17.118-.054.223.145.263.091.378.144.093.043.182-.048.216-.099z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__s)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M550.644 81.143c-.066-.076-.17-.208-.06-.131.137.096.448.62.457-.051.008-.672-.036-.715.177-.813s.623.286.671.264.308-.3.438-.042.326.582.466.708c.112.102.22.132.26.135l.36.503-.006.575-.058.535c-.024-.01-.12.036-.307.3-.188.265-.553.456-.712.518l-.362-.024-.641.135a14 14 0 0 0-.642-.786c-.285-.315-.133-.035-.427-.472-.235-.35-.196-.885-.146-1.11-.031-.06-.054-.153.106-.048.201.13.237.082.341.13.083.038.164-.044.193-.09z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__t)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M572.312 90.745c.112.2.504.205.687.181.144-.019.509-.018.812.141.379.199 1.231-.387 2.205-1.443s.66-.367 1.514-1.271c.855-.905.567-.45.923-1.652s.315-.69.362-2.088-.529-.743-.606-1.42c-.076-.678-.213-1.215-.822-1.534-.61-.32-.744-.923-1.834-1.352-1.09-.428-.764-.008-1.008-.136s-.743-.674-1.925-2.253-.933-1.022-2.435-1.275-.65-.59-1.651-.865-.473-.781-.694-1.075-.478.106-1.416 1.785c-.939 1.68-.491.064-1.249.983-.759.92-.469.965-.443 2.046s.948.745.943 1.881.79.84.988 1.55c.199.709.704.368 1.18.831s.512 1.087.262 1.347.087.721.413 1.39c.326.67 1.096 1.607 1.152 2.383.056.777 1.014.816 1.501 1.07.487.256 1.001.525 1.141.776"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#F1F1F1",
    strokeWidth: 0.5,
    d: "M293.559 17.432c0-1.041-4.737-1.885-10.581-1.885s-10.581.844-10.581 1.885"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeWidth: 0.5,
    d: "M293.559 17.432c0-1.041-4.737-1.885-10.581-1.885s-10.581.844-10.581 1.885"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 283.226,
    cy: 27.889,
    fill: "#333",
    rx: 10.598,
    ry: 1.83
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 283.226,
    cy: 37.818,
    fill: "#333",
    rx: 10.598,
    ry: 1.83
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 283.226,
    cy: 57.725,
    fill: "#333",
    rx: 10.598,
    ry: 1.83
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 283.283,
    cy: 75.932,
    fill: "#333",
    rx: 10.598,
    ry: 1.83
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 283.226,
    cy: 66.736,
    fill: "#333",
    rx: 10.598,
    ry: 1.83
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeWidth: 0.5,
    d: "m272.478 17.08.001 56.991M293.501 17.502v66.17M293.542 27.565V17.477v17.105M293.542 20.345v-2.868 4.863"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BABABA",
    strokeWidth: 0.5,
    d: "M293.459 28.104c0-1.041-4.715-1.885-10.531-1.885s-10.531.844-10.531 1.884M293.459 38.033c0-1.04-4.715-1.885-10.531-1.885s-10.531.844-10.531 1.885M293.459 57.94c0-1.041-4.715-1.885-10.531-1.885s-10.531.843-10.531 1.885M293.516 76.147c0-1.041-4.715-1.885-10.531-1.885s-10.531.844-10.531 1.885M293.459 66.951c0-1.04-4.715-1.885-10.531-1.885s-10.531.844-10.531 1.885"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M293.349 27.993c.019-.127-.142-.44-.933-.684-.791-.243-1.996-.523-2.499-.633"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5656",
    stroke: "#FF000F",
    strokeWidth: 0.5,
    d: "M272.579 49.16v-3.147c1.77-1.129 5.726-1.374 7.546-1.487l.057-.004c.912-.057 4.392-.286 7.968.198 2.856.387 4.747.95 5.323 1.293v3.092c0 .048-.069.074-.105.042-.339-.298-1.318-.813-3.319-1.137-2.848-.46-5.499-.504-10.07-.329-3.311.127-6.423.962-7.318 1.522-.035.022-.082-.002-.082-.043Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FF000F",
    d: "M293.49 66.687c-.577-.354-1.777-1.242-7.279-1.578M272.524 37.87c.576-.353 1.776-1.241 7.278-1.577"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.8,
    d: "M293.641 46.195c-.576-.354-1.776-1.242-7.278-1.578"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FF000F",
    strokeWidth: 0.4,
    d: "M283.069 47.704c2.955 0 5.625.205 7.552.533.965.165 1.734.359 2.258.57q.392.16.572.312c.122.102.145.174.145.215 0 .04-.023.113-.145.215q-.18.152-.572.312c-.524.211-1.293.405-2.258.57-1.927.328-4.597.533-7.552.533s-5.625-.205-7.553-.533c-.965-.165-1.734-.359-2.257-.57a2.2 2.2 0 0 1-.573-.312c-.121-.102-.145-.174-.145-.215 0-.04.024-.113.145-.215q.18-.151.573-.312c.523-.211 1.292-.405 2.257-.57 1.928-.329 4.598-.533 7.553-.533Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "m309 34.1 15-6.1v215h-15z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeWidth: 0.5,
    d: "M11.244 255.633c96.51-.648 201.272-1.29 297.782-.763"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F1F1F1",
    strokeWidth: 0.5,
    d: "M342.314 255.586h38.035"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#333",
    strokeWidth: 0.5,
    d: "M342.88 255.586c14.953.044-2.248.002 19.862-.004"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeWidth: 0.5,
    d: "M238.8 24.102v213.89M242.048 25.953V236.87M225.246 18.031v220.142M42.28 1.445l.836 256.115"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeWidth: 0.2,
    d: "m41.619 1.445.837 256.115"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeWidth: 0.5,
    d: "M339.159 107.387v130.66M427.35 37.656V259.5M1.497 255.032l221.083 8.227 36.471-8.54M257.643 243.492v24.942M233.512 24.71v242.782"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.773,
    cy: 10.908,
    fill: "url(#selectivity_card_dark_svg__u)",
    rx: 10.773,
    ry: 10.908,
    transform: "matrix(.69555 -.71848 .74108 .67142 413.404 220.605)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.773,
    cy: 10.908,
    fill: "url(#selectivity_card_dark_svg__v)",
    rx: 10.773,
    ry: 10.908,
    transform: "matrix(.69555 -.71848 .74108 .67142 396.461 225.719)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.773,
    cy: 10.908,
    fill: "url(#selectivity_card_dark_svg__w)",
    rx: 10.773,
    ry: 10.908,
    transform: "matrix(.69555 -.71848 .74108 .67142 427.15 217.41)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.773,
    cy: 10.908,
    fill: "url(#selectivity_card_dark_svg__x)",
    rx: 10.773,
    ry: 10.908,
    transform: "matrix(.69555 -.71848 .74108 .67142 437.379 230.836)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.773,
    cy: 10.908,
    fill: "url(#selectivity_card_dark_svg__y)",
    rx: 10.773,
    ry: 10.908,
    transform: "matrix(.69555 -.71848 .74108 .67142 424.734 228.754)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.819,
    cy: 10.454,
    fill: "#BABABA",
    rx: 9.819,
    ry: 10.454,
    transform: "matrix(.74966 -.66182 .68622 .7274 433.87 238.336)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.819,
    cy: 10.454,
    fill: "url(#selectivity_card_dark_svg__z)",
    rx: 9.819,
    ry: 10.454,
    transform: "matrix(.74966 -.66182 .68622 .7274 433.87 238.336)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.772,
    cy: 9.338,
    fill: "#BABABA",
    rx: 8.772,
    ry: 9.338,
    transform: "matrix(.74966 -.66182 .68622 .7274 443.383 246.352)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.772,
    cy: 9.338,
    fill: "url(#selectivity_card_dark_svg__A)",
    rx: 8.772,
    ry: 9.338,
    transform: "matrix(.74966 -.66182 .68622 .7274 443.383 246.352)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.556,
    cy: 11.978,
    fill: "#BABABA",
    rx: 11.556,
    ry: 11.978,
    transform: "matrix(.77894 -.6271 .6523 .75796 372.81 242.211)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.556,
    cy: 11.978,
    fill: "url(#selectivity_card_dark_svg__B)",
    rx: 11.556,
    ry: 11.978,
    transform: "matrix(.77894 -.6271 .6523 .75796 372.81 242.211)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.556,
    cy: 11.978,
    fill: "#BABABA",
    rx: 11.556,
    ry: 11.978,
    transform: "matrix(.77894 -.6271 .6523 .75796 302.196 242.25)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.556,
    cy: 11.978,
    fill: "url(#selectivity_card_dark_svg__C)",
    rx: 11.556,
    ry: 11.978,
    transform: "matrix(.77894 -.6271 .6523 .75796 302.196 242.25)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.556,
    cy: 11.978,
    fill: "#BABABA",
    rx: 11.556,
    ry: 11.978,
    transform: "matrix(.77894 -.6271 .6523 .75796 316.106 242.211)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.556,
    cy: 11.978,
    fill: "url(#selectivity_card_dark_svg__D)",
    rx: 11.556,
    ry: 11.978,
    transform: "matrix(.77894 -.6271 .6523 .75796 316.106 242.211)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.076,
    cy: 8.371,
    fill: "#BABABA",
    rx: 8.076,
    ry: 8.371,
    transform: "matrix(.77894 -.6271 .6523 .75796 314.353 229.781)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.076,
    cy: 8.371,
    fill: "url(#selectivity_card_dark_svg__E)",
    rx: 8.076,
    ry: 8.371,
    transform: "matrix(.77894 -.6271 .6523 .75796 314.353 229.781)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.076,
    cy: 8.371,
    fill: "#BABABA",
    rx: 8.076,
    ry: 8.371,
    transform: "matrix(.77894 -.6271 .6523 .75796 319.611 233.305)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.076,
    cy: 8.371,
    fill: "url(#selectivity_card_dark_svg__F)",
    rx: 8.076,
    ry: 8.371,
    transform: "matrix(.77894 -.6271 .6523 .75796 319.611 233.305)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.892,
    cy: 13.363,
    fill: "#BABABA",
    rx: 12.892,
    ry: 13.363,
    transform: "matrix(.77894 -.6271 .6523 .75796 384.558 240.891)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.892,
    cy: 13.363,
    fill: "url(#selectivity_card_dark_svg__G)",
    rx: 12.892,
    ry: 13.363,
    transform: "matrix(.77894 -.6271 .6523 .75796 384.558 240.891)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.867,
    cy: 11.264,
    fill: "#BABABA",
    rx: 10.867,
    ry: 11.264,
    transform: "matrix(.77894 -.6271 .6523 .75796 426.387 244.789)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.867,
    cy: 11.264,
    fill: "url(#selectivity_card_dark_svg__H)",
    rx: 10.867,
    ry: 11.264,
    transform: "matrix(.77894 -.6271 .6523 .75796 426.387 244.789)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.473,
    cy: 19.148,
    fill: "#BABABA",
    rx: 18.473,
    ry: 19.148,
    transform: "matrix(.77894 -.6271 .6523 .75796 396.982 236.035)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.473,
    cy: 19.148,
    fill: "url(#selectivity_card_dark_svg__I)",
    rx: 18.473,
    ry: 19.148,
    transform: "matrix(.77894 -.6271 .6523 .75796 396.982 236.035)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M316.699 94.47 112.537.21h-8.461l212.623 96.202z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__J)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F1",
    d: "M42.719 2.781-.074 10.415v4.82L42.72 7.551l255.832 96.306 4.331-.221z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__K)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFA200",
    d: "M42.615 7.219-.176 14.853v4.819l42.791-7.683 255.832 96.307 4.331-.221z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC582",
    d: "M42.615 5.406-.176 13.04v4.82l42.791-7.683 255.832 96.306 4.331-.221z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeWidth: 0.5,
    d: "m.816 126.977 40.873-3.5 208.813 44.726"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDBDB",
    strokeWidth: 0.5,
    d: "m-.174 274.613 225.491-36.668h13.403l3.256-.871h7.565"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2A2A2A",
    strokeWidth: 0.5,
    d: "m42.93 123.773 12.06 1.618"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BABABA",
    strokeWidth: 0.6,
    d: "M238.793 206.625v48.049"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.8,
    d: "m-.019 127.063 20.909-1.817"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M238.78 237.791v-9.229"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__L)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#BABABA",
    strokeWidth: 3,
    d: "M134.298 90.836v5.525a3 3 0 0 0 3 3h51.746a3 3 0 0 1 3 3v1.5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__M)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#BABABA",
    strokeWidth: 3,
    d: "M129.892 90.836v5.525a3 3 0 0 1-3 3H75.147a3 3 0 0 0-3 3v1.5"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    d: "m324.498 29.18 102.5 45.156v-.082l-102.5-44.57z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeWidth: 0.3,
    d: "m411.331 84.915 34.339 15.294M262.663-41.685c0-1.041 4.738-1.885 10.581-1.885 5.844 0 10.581.843 10.581 1.885"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeWidth: 0.5,
    d: "m411.709 117.573 31.216 12.633M258.578-3.654c0-1.041 4.737-1.885 10.581-1.885s10.581.844 10.581 1.885"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "m377.841 166.789 65.45 22.595"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#333",
    strokeWidth: 0.5,
    d: "m433.19 185.953 10.158 3.551"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M378 166.727 401.914 175m25.586-41.5v5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#333",
    strokeWidth: 0.5,
    d: "m247.782 167.508 30.663 7.143"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeWidth: 0.5,
    d: "m302.803 106.352 13.95 5.429"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__N)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.191,
    height: 80.234,
    x: 106.809,
    y: 11,
    fill: "#666",
    rx: 2
  })), /*#__PURE__*/React.createElement("rect", {
    width: 50.191,
    height: 80.234,
    x: 106.809,
    y: 11,
    fill: "#666",
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__O)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.601,
    height: 34.343,
    x: 110.153,
    y: 35.16,
    fill: "#666",
    rx: 0.5
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 113.483,
    cy: 39.282,
    r: 1.7,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.758,
    cy: 72.829,
    r: 1.7,
    fill: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__P)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.048,
    height: 30.411,
    x: 116.153,
    y: 36.176,
    fill: "#666",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.848,
    height: 30.211,
    x: 116.253,
    y: 36.276,
    stroke: "#666",
    strokeWidth: 0.2,
    rx: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FF000F",
    d: "M116.175 37.175a.3.3 0 0 1 .3-.3h30.213a.3.3 0 0 1 .3.3v2.977h-30.813z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.208,
    height: 16.662,
    x: 128.073,
    y: 42.766,
    fill: "#F9F9F9",
    rx: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EBEBEB",
    strokeWidth: 0.1,
    d: "M117.2 69.777v2.555m0 6.67v-6.67m14.614-2.555v9.225m14.898-9.225v2.555m0 6.67v-6.67m-29.512 0h29.512"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#787878",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    d: "M155.491 20.016v8.604h-12.694v-8.604zm-13.194 0v8.604h-33.979v-8.604zm-21.005 8.487h.5v-8.469h-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EBEBEB",
    strokeWidth: 0.1,
    d: "M108.381 21.336h47.346m-47.346.993h47.346m-47.346.992h47.346m-47.346.993h47.346m-47.346.992h47.346m-47.346.993h47.346m-47.346.993h47.346"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__Q)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M107.128 79.289h49.871v.741h-49.871z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#F1F1F1",
    d: "m116.153 40 4.394-.008 4.393-.007M139.358 40h7.63"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FCDB2E",
    strokeWidth: 0.8,
    d: "M120.503 48.688h6.306"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00DD16",
    strokeWidth: 1.5,
    d: "M120.503 59.117h6.306"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.5,
    d: "M147.201 44h-2.435M116.175 44.055h3.638M147.201 59.117h-2.435M116.175 59.117h3.638"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M116.175 48.688h3.638M144.481 48.688h2.753"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FF000F",
    strokeWidth: 2,
    d: "M120.166 44h5.143000000000001M138.809 44h5.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00DD16",
    strokeWidth: 0.8,
    d: "M138.809 48.688h5.009"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00DD16",
    strokeWidth: 1.5,
    d: "M138.809 59.117h5.5"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__R)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.828,
    height: 7.102,
    x: 125.235,
    y: 38.516,
    fill: "#F9F9F9",
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    width: 9.417,
    height: 1.82,
    x: 127.469,
    y: 39.805,
    fill: "#2A2A2A",
    rx: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AE5F02",
    d: "m331.92 59.953 25.599 11.52v25.01L331.92 86.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FB9722",
    stroke: "#1F1F1F",
    strokeWidth: 2,
    d: "m363.008 65.376.455 33.758-32.075-11.877-.486-36.058z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1F1F1F",
    strokeWidth: 2,
    d: "m363.16 65.727.451 33.408-32.223-11.879-.486-36.044z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AE5F02",
    d: "m386.02 82.04 18.648 7.683v24.55l-18.648-5.775z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FB9722",
    stroke: "#1F1F1F",
    strokeWidth: 2,
    d: "m409.435 85.494.418 30.974-24.129-8.988-.437-32.412z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1F1F1F",
    strokeWidth: 2,
    d: "m409.784 85.49.418 30.973-24.243-8.989-.437-32.412z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "m363.927 64.625 20.396 9.052.465 34.511-20.377-7.694z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F1F1F1",
    strokeWidth: 0.3,
    d: "m423.318 82.934.584 45.463"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeWidth: 0.3,
    d: "m423.318 82.938.584 45.463M411.22 78.52l.584 45.463"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.6,
    d: "m419.836 88.777 3.494 1.514v16.201"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeWidth: 0.2,
    d: "m438.475 81.734 106.215 52.737"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BABABA",
    strokeWidth: 0.2,
    d: "m455.303 102.523 85.033 42.103"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BABABA",
    strokeWidth: 0.5,
    d: "m452.567 88.651 66.511 32.897m-66.51-35.583 67.066 32.879M465.281 111.415l34.648 16.871m-34.648-20.864 34.648 17.052"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M483.05 59.806a1.83 1.83 0 0 1 3.66-.003l.281 158.583c.004 2.35-3.368 2.733-3.892.443a2 2 0 0 1-.049-.439z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.84,
    height: 4.571,
    x: 505.131,
    y: 112.57,
    fill: "#666",
    rx: 2.286,
    transform: "rotate(-84.772 505.131 112.57)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.34,
    height: 4.071,
    x: 466.989,
    y: 108.75,
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.5,
    rx: 2.036,
    transform: "rotate(-84.772 466.989 108.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.84,
    height: 4.571,
    x: 462.853,
    y: 91.297,
    fill: "#666",
    rx: 2.286,
    transform: "rotate(-84.772 462.853 91.297)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.34,
    height: 4.071,
    x: 494.612,
    y: 121.961,
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.5,
    rx: 2.036,
    transform: "rotate(-84.772 494.612 121.961)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeWidth: 0.3,
    d: "M487 15v246"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EBEBEB",
    strokeWidth: 0.3,
    d: "M487 58v203"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeWidth: 0.3,
    d: "M452.576 52.008v73.242M465.207 101.32l-.026 45.078M500.444 117.547l-.026 45.078"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDBDB",
    strokeWidth: 0.3,
    d: "M519.8 58.078v116.695"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#333",
    d: "m452.813 85.984 11.992 5.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "m480.419 102.297 2.797 1.336v10.457M508.019 108.031c.876.484 2.209 1.484 1.817 2.933-.448 1.649-1.845 1.648-2.376 1.732M469.606 104.438c.875.483 2.209 1.483 1.816 2.932-.447 1.649-1.844 1.648-2.375 1.732"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    stroke: "#BABABA",
    d: "M29.25 176.438c1.014 0 1.98.573 2.711 1.594s1.199 2.456 1.199 4.065c0 1.608-.468 3.044-1.199 4.064-.73 1.021-1.696 1.595-2.711 1.595-1.016 0-1.982-.573-2.713-1.595-.731-1.02-1.199-2.456-1.199-4.064s.468-3.044 1.199-4.065 1.697-1.594 2.713-1.594Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    d: "m496.332 120.163 12.306-10.688m0 0c6.59 6.241 68.091 32.495 88.976-32.617m-88.976 32.617c6.59 6.241 84.062 18.161 104.947-46.952M467.491 107.511l-2.402-15.96c-.283-1.88 2.427-3.672 4.187-2.95 16.475 6.754 64.237 14.313 77.15-26.492"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    d: "m467.49 107.512-2.401-15.96c-.283-1.88 2.698-4.204 4.575-3.896 19.293 3.167 79.851-2.761 87.746-31.113"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__S)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F1",
    d: "M557.578 205.14v-5.58l38.035-.966 67.833 1.284v4.062l4.895 10.501-.3 15.428v2.156l-1.279.15v2.596l-2.233 4.455-1.083 7.776v6.438l.615 1.21 1.798 8.277h-3.549l-6.719-.871h-2.413l.331 2.275-4.732.58-7.286-1.064-23.209 3.215.455 2.637-5.762.465-6.823-1.252-4.094.399v2.869l-3.942.698-7.718-1.861v-2.105l-14.348-2.362-10.494-2.335h-3.294l-5.868-1.053 2.368-10.951-1.184-20.752h-3.133v-18.221z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__T)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F1",
    d: "m574.569 157.291-16.858 4.816v36.726l37.328-1.204 66.829 1.204v-34.92l-69.839-8.429z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9A9898",
    d: "M557.578 205.14v-5.58l38.035-.966 67.833 1.284v4.062l4.895 10.501-.3 15.428v2.156l-1.279.15v2.596l-2.233 4.455-1.083 7.776v6.438l.615 1.21 1.798 8.277h-3.549l-6.719-.871h-2.413l.331 2.275-4.732.58-7.286-1.064-23.209 3.215.455 2.637-5.762.465-6.823-1.252-4.094.399v2.869l-3.942.698-7.718-1.861v-2.105l-14.348-2.362-10.494-2.335h-3.294l-5.868-1.053 2.368-10.951-1.184-20.752h-3.133v-18.221z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m583.368 234.39 14.026 1.246 71.51-4.163"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#878585",
    d: "M564.726 200.043h1.903v25.945h-1.903z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__U)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9A9898",
    d: "M594.588 216.777h-8.727v15.632l8.727.751z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__V)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "m656.859 216.383 3.369.207v13.586l-3.369-.305z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__W)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9A9898",
    d: "M660.29 216.633h5.854v13.391h-5.854z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.956,
    cy: 0.572,
    fill: "#666",
    rx: 0.956,
    ry: 0.572,
    transform: "matrix(-.6781 .73497 .6487 .76105 568.359 223.059)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.929,
    cy: 0.575,
    fill: "#666",
    rx: 0.929,
    ry: 0.575,
    transform: "matrix(-.7142 .69995 .61046 .79205 569.505 224.547)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "m569.862 225.012-1.132-1.496-1.347 1.295 1.132 1.496z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__X)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 576.786,
    cy: 234.721,
    fill: "#9A9898",
    rx: 5.713,
    ry: 10.389
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9A9898",
    d: "M572.196 224.312h4.761v20.79h-4.761z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__Y)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 572.107,
    cy: 234.721,
    fill: "#9A9898",
    rx: 5.713,
    ry: 10.389
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 572.7,
    cy: 233.458,
    fill: "#666",
    rx: 1.975,
    ry: 5.235
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M564.504 228.246h8.395v10.421h-8.395z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__Z)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 563.131,
    cy: 233.514,
    fill: "#9A9898",
    rx: 5.476,
    ry: 8.76
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__aa)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__ab)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 565.266,
    cy: 227.432,
    fill: "#9A9898",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__ac)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 564.309,
    cy: 226.455,
    fill: "#9A9898",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__ad)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 563.372,
    cy: 225.857,
    fill: "#9A9898",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__ae)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 562.361,
    cy: 225.736,
    fill: "#9A9898",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__af)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 561.351,
    cy: 226.131,
    fill: "#9A9898",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__ag)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 560.45,
    cy: 226.947,
    fill: "#9A9898",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__ah)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 559.764,
    cy: 227.861,
    fill: "#9A9898",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__ai)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 559.061,
    cy: 229.123,
    fill: "#9A9898",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__aj)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 558.574,
    cy: 230.498,
    fill: "#9A9898",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__ak)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 558.376,
    cy: 232.318,
    fill: "#9A9898",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__al)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 558.376,
    cy: 234.01,
    fill: "#9A9898",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__am)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 558.629,
    cy: 235.869,
    fill: "#9A9898",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__an)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 558.971,
    cy: 237.439,
    fill: "#9A9898",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__ao)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 559.639,
    cy: 238.935,
    fill: "#9A9898",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__ap)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 560.522,
    cy: 239.943,
    fill: "#9A9898",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__aq)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 561.262,
    cy: 240.627,
    fill: "#9A9898",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__ar)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 562.164,
    cy: 241.189,
    fill: "#9A9898",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__as)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 563.12,
    cy: 241.334,
    fill: "#9A9898",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__at)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 564.076,
    cy: 241.295,
    fill: "#9A9898",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__au)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 564.924,
    cy: 240.646,
    fill: "#9A9898",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__av)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 565.843,
    cy: 239.783,
    fill: "#9A9898",
    rx: 0.235,
    ry: 0.685
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__aw)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 566.528,
    cy: 238.631,
    fill: "#9A9898",
    rx: 0.235,
    ry: 0.685
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__ax)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 562.805,
    cy: 233.435,
    fill: "#9A9898",
    rx: 3.403,
    ry: 5.657
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.956,
    cy: 0.572,
    fill: "#666",
    rx: 0.956,
    ry: 0.572,
    transform: "matrix(.6781 .73497 -.6487 .76105 578.433 223.223)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.929,
    cy: 0.575,
    fill: "#666",
    rx: 0.929,
    ry: 0.575,
    transform: "matrix(.7142 .69995 -.61046 .79205 577.287 224.715)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "m576.93 225.176 1.132-1.496 1.347 1.295-1.132 1.496z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__ay)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#selectivity_card_dark_svg__az)",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M575.247 244.984v8.893a2 2 0 0 0 1.512 1.939l17.381 4.375c.236.059.48.075.721.047l68.26-8.007"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 1.989,
    height: 5.569,
    x: 600.045,
    y: 257.277,
    fill: "#666",
    rx: 0.995,
    transform: "rotate(-7.177 600.045 257.277)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.989,
    height: 5.569,
    x: 622.068,
    y: 254.496,
    fill: "#666",
    rx: 0.995,
    transform: "rotate(-7.177 622.068 254.496)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.989,
    height: 5.569,
    x: 639.436,
    y: 252.312,
    fill: "#666",
    rx: 0.995,
    transform: "rotate(-7.177 639.436 252.312)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.989,
    height: 5.569,
    x: 657.628,
    y: 250.02,
    fill: "#666",
    rx: 0.995,
    transform: "rotate(-7.177 657.628 250.02)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B1B1B1",
    d: "m649.263 205.125 12.705-.254 4.253 9.268h-13.342zM648.448 205.173l-35.563-.302 4.072 10.51 35.438-1.094z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__aA)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M612.718 204.893v-4.591c3.547-.336 4.748 1.337 4.868 2.179.097.673-.384 8.936-.625 12.9h-.465l.089-.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9A5A5",
    d: "M612.607 205.065v-4.591c3.31-.336 4.431 1.337 4.543 2.179.09.673-.359 8.936-.583 12.9z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 614.665,
    cy: 202.84,
    fill: "#333",
    rx: 0.638,
    ry: 0.875
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__aB)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M653.438 202.921c.097.592-.384 7.862-.625 11.35h-.418l.042-.818-3.867-8.409v-3.891h-.111l.111-.149c3.547-.296 4.748 1.176 4.868 1.917"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9A5A5",
    d: "M648.459 205.196v-4.04c3.31-.296 4.431 1.177 4.543 1.917.09.592-.378 7.7-.602 11.188z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 650.517,
    cy: 203.242,
    fill: "#333",
    rx: 0.638,
    ry: 0.77
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B1B1B1",
    d: "M612.542 204.859h-17.748l3.123 10.511h18.661z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.459,
    height: 5.79,
    x: 599.862,
    y: 216.977,
    fill: "#F5F5F5",
    rx: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FF000F",
    clipPath: "url(#selectivity_card_dark_svg__aC)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M604.999 221.705h.168c.503-.032.855-.547.855-1.16 0-.208-.034-.416-.109-.58h-.914zM604.915 219.965h-.838v1.751h.838zM605.862 219.857a1.06 1.06 0 0 0-.327-.361.87.87 0 0 0 .252-.624c0-.427-.26-.767-.587-.767h-.201v1.752zM604.915 218.105h-.838v1.752h.838zM607.262 221.717h.168c.503-.033.855-.547.855-1.16 0-.208-.034-.416-.109-.58h-.914zM607.178 219.965h-.838v1.751h.838zM608.125 219.857a1.05 1.05 0 0 0-.327-.361.87.87 0 0 0 .252-.624c0-.427-.26-.767-.587-.767h-.201v1.752zM607.178 218.105h-.838v1.752h.838zM601.538 219.965l-.478 1.751h.695l.202-.766h.444v-.985zM602.401 218.105h-.361l-.477 1.752h.838zM602.485 220.95h.444l.201.766h.696l-.478-1.751h-.863zM603.323 219.857l-.478-1.752h-.36v1.752z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__aD)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#selectivity_card_dark_svg__aE)",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "m581.419 241.562 13.743 12.522c.585.702 2.038.894 2.938.737l68.695-11.979"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 1.989,
    height: 10.093,
    x: 601.373,
    y: 246.555,
    fill: "#666",
    rx: 0.995,
    transform: "rotate(.54 601.373 246.555)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.989,
    height: 10.093,
    x: 623.57,
    y: 243.402,
    fill: "#666",
    rx: 0.995,
    transform: "rotate(.54 623.57 243.402)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.989,
    height: 10.093,
    x: 640.907,
    y: 240.902,
    fill: "#666",
    rx: 0.995,
    transform: "rotate(.54 640.907 240.902)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.989,
    height: 10.093,
    x: 659.69,
    y: 238.016,
    fill: "#666",
    rx: 0.995,
    transform: "rotate(.54 659.69 238.016)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__aF)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 593.807,
    cy: 253.944,
    fill: "#9A9898",
    rx: 2.436,
    ry: 3.897
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__aG)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 593.662,
    cy: 253.911,
    fill: "#9A9898",
    rx: 1.514,
    ry: 2.517
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m598.812 269.873.8 2.823c2.057-.361 2.442-1.581 2.363-2.118-.063-.429-1.775-5.431-2.601-7.829l-.262.074.212.557z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9A9898",
    d: "m598.719 269.783.8 2.823c1.924-.323 2.264-1.53 2.18-2.066-.066-.428-1.76-5.435-2.577-7.836z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.391,
    cy: 0.559,
    fill: "#333",
    rx: 0.391,
    ry: 0.559,
    transform: "scale(1 -1)rotate(15.834 1252.013 2017.526)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m596.368 270.037.801 2.823c2.057-.361 2.442-1.581 2.363-2.118-.063-.429-1.775-5.431-2.601-7.829l-.263.074.213.557z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9A9898",
    d: "m596.276 269.944.8 2.822c2.011-.347 2.38-1.563 2.3-2.099-.065-.429-1.77-5.433-2.593-7.832z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m558.365 260.951-.8 2.823c-2.057-.36-2.442-1.581-2.363-2.118.063-.429 1.774-5.431 2.601-7.829l.262.074-.212.557z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9A9898",
    d: "m558.458 260.862-.8 2.822c-1.924-.323-2.264-1.53-2.181-2.066.067-.428 1.761-5.435 2.578-7.836z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 558.945,
    cy: 255.508,
    fill: "#333",
    rx: 0.391,
    ry: 0.559,
    transform: "rotate(-164.166 558.945 255.508)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m560.809 261.119-.801 2.823c-2.056-.36-2.442-1.581-2.363-2.118.064-.429 1.775-5.431 2.602-7.829l.262.074-.212.557z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9A9898",
    d: "m560.902 261.03-.801 2.822c-2.01-.347-2.38-1.563-2.299-2.099.064-.429 1.769-5.433 2.593-7.832z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m616.298 267.111.958 2.773c2.033-.476 2.349-1.716 2.24-2.248-.087-.424-2.078-5.322-3.038-7.67l-.258.089.243.544z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9A9898",
    d: "m616.2 267.029.959 2.773c1.902-.431 2.174-1.656 2.06-2.185-.091-.424-2.064-5.328-3.015-7.679z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.391,
    cy: 0.559,
    fill: "#333",
    rx: 0.391,
    ry: 0.559,
    transform: "scale(1 -1)rotate(19.066 1087.71 1697.892)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m612.418 267.498.958 2.772c2.033-.475 2.349-1.716 2.24-2.247-.087-.425-2.078-5.323-3.038-7.67l-.258.089.243.544z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9A9898",
    d: "m612.32 267.416.958 2.772c1.988-.46 2.288-1.695 2.178-2.225-.089-.425-2.073-5.325-3.031-7.674z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m651.081 261.742.841 2.562c2.034-.461 2.397-1.614 2.309-2.105-.069-.393-1.85-4.914-2.71-7.082l-.259.085.22.503z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9A9898",
    d: "m650.987 261.664.841 2.561c1.903-.417 2.221-1.555 2.129-2.045-.073-.392-1.836-4.919-2.687-7.089z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.391,
    cy: 0.514,
    fill: "#333",
    rx: 0.391,
    ry: 0.514,
    transform: "scale(1 -1)rotate(18.176 1128.52 1900.965)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m647.218 262.137.841 2.561c2.035-.46 2.397-1.613 2.31-2.105-.07-.393-1.851-4.914-2.711-7.081l-.259.085.22.502z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9A9898",
    d: "m647.125 262.055.84 2.561c1.99-.445 2.336-1.593 2.248-2.084-.071-.393-1.846-4.916-2.703-7.084z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m663.226 260.714.693 2.442c1.724-.296 2.039-1.347 1.968-1.81-.056-.371-1.529-4.702-2.241-6.778l-.219.062.182.483z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9A9898",
    d: "m663.148 260.636.692 2.442c1.613-.264 1.89-1.304 1.816-1.767-.059-.37-1.518-4.705-2.222-6.783z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.327,
    cy: 0.484,
    fill: "#333",
    rx: 0.327,
    ry: 0.484,
    transform: "scale(1 -1)rotate(15.834 1252.526 2251.066)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m659.957 260.831.692 2.442c1.725-.295 2.039-1.346 1.969-1.81-.056-.371-1.53-4.702-2.241-6.778l-.22.062.183.483z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9A9898",
    d: "m659.878 260.749.693 2.442c1.685-.285 1.987-1.332 1.915-1.795-.057-.371-1.525-4.703-2.234-6.78zM574.569 157.291l-16.858 4.816v36.726l37.328-1.204 66.829 1.204v-34.92l-69.839-8.429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "m606.957 158.621 6.622 1.204.602 36.726h-7.224z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 611.006,
    cy: 162.795,
    fill: "#9A9898",
    rx: 2.384,
    ry: 2.787
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 611.051,
    cy: 162.774,
    fill: "#666",
    rx: 0.98,
    ry: 1.145
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 610.452,
    cy: 160.728,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 611.754,
    cy: 160.728,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 612.808,
    cy: 162.099,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 612.808,
    cy: 163.255,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 611.733,
    cy: 164.861,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 610.575,
    cy: 164.861,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 609.293,
    cy: 163.255,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 609.232,
    cy: 162.099,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "m614.182 160.039 6.622 1.162.603 35.451h-6.89z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 618.255,
    cy: 163.877,
    fill: "#9A9898",
    rx: 2.384,
    ry: 2.787
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 618.3,
    cy: 163.856,
    fill: "#666",
    rx: 0.98,
    ry: 1.145
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 617.701,
    cy: 161.81,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 619.004,
    cy: 161.81,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 620.058,
    cy: 163.181,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 620.058,
    cy: 164.338,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 618.982,
    cy: 165.943,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 617.825,
    cy: 165.943,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 616.543,
    cy: 164.338,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 616.481,
    cy: 163.181,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "m650.401 163.84 6.623 1.063.602 32.436h-7.225z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 654.474,
    cy: 167.681,
    fill: "#9A9898",
    rx: 2.384,
    ry: 2.787
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 654.52,
    cy: 167.661,
    fill: "#666",
    rx: 0.98,
    ry: 1.145
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 653.92,
    cy: 165.615,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 655.223,
    cy: 165.615,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 656.277,
    cy: 166.986,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 656.277,
    cy: 168.142,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 655.202,
    cy: 169.748,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 654.044,
    cy: 169.748,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 652.762,
    cy: 168.142,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 652.7,
    cy: 166.986,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 654.474,
    cy: 192.635,
    fill: "#9A9898",
    rx: 2.384,
    ry: 2.787
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 654.52,
    cy: 192.614,
    fill: "#666",
    rx: 0.98,
    ry: 1.145
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 653.92,
    cy: 190.568,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 655.223,
    cy: 190.568,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 656.277,
    cy: 191.939,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 656.277,
    cy: 193.095,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 655.202,
    cy: 194.697,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 654.044,
    cy: 194.697,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 652.762,
    cy: 193.095,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 652.7,
    cy: 191.939,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "m643.048 162.652 6.623 1.097.481 33.569h-7.104z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 647.122,
    cy: 166.494,
    fill: "#9A9898",
    rx: 2.384,
    ry: 2.787
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 647.167,
    cy: 166.473,
    fill: "#666",
    rx: 0.98,
    ry: 1.145
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 646.568,
    cy: 164.427,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 647.87,
    cy: 164.427,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 648.924,
    cy: 165.798,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 648.924,
    cy: 166.955,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 647.849,
    cy: 168.56,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 646.691,
    cy: 168.56,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 645.409,
    cy: 166.955,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 645.348,
    cy: 165.798,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 647.238,
    cy: 192.369,
    fill: "#9A9898",
    rx: 2.384,
    ry: 2.787
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 647.283,
    cy: 192.352,
    fill: "#666",
    rx: 0.98,
    ry: 1.145
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 646.683,
    cy: 190.306,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 647.986,
    cy: 190.306,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 649.04,
    cy: 191.673,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 649.04,
    cy: 192.83,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 647.965,
    cy: 194.435,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 646.807,
    cy: 194.435,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 645.525,
    cy: 192.83,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 645.463,
    cy: 191.673,
    fill: "#666",
    rx: 0.215,
    ry: 0.252
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m555.51 199.388 39.679-.95 69.054 1.186"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.312,
    cy: 9.652,
    fill: "#BABABA",
    rx: 9.312,
    ry: 9.652,
    transform: "matrix(.77894 -.6271 .6523 .75796 507.901 234.793)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.312,
    cy: 9.652,
    fill: "url(#selectivity_card_dark_svg__aH)",
    rx: 9.312,
    ry: 9.652,
    transform: "matrix(.77894 -.6271 .6523 .75796 507.901 234.793)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.556,
    cy: 11.978,
    fill: "#BABABA",
    rx: 11.556,
    ry: 11.978,
    transform: "matrix(.77894 -.6271 .6523 .75796 489.062 226.059)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.556,
    cy: 11.978,
    fill: "url(#selectivity_card_dark_svg__aI)",
    rx: 11.556,
    ry: 11.978,
    transform: "matrix(.77894 -.6271 .6523 .75796 489.062 226.059)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.076,
    cy: 8.371,
    fill: "#BABABA",
    rx: 8.076,
    ry: 8.371,
    transform: "matrix(.77894 -.6271 .6523 .75796 518.966 243.988)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.076,
    cy: 8.371,
    fill: "url(#selectivity_card_dark_svg__aJ)",
    rx: 8.076,
    ry: 8.371,
    transform: "matrix(.77894 -.6271 .6523 .75796 518.966 243.988)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.973,
    cy: 19.666,
    fill: "#BABABA",
    rx: 18.973,
    ry: 19.666,
    transform: "matrix(.77894 -.6271 .6523 .75796 458.91 230.266)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.973,
    cy: 19.666,
    fill: "url(#selectivity_card_dark_svg__aK)",
    rx: 18.973,
    ry: 19.666,
    transform: "matrix(.77894 -.6271 .6523 .75796 458.91 230.266)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M525.67 237.407c3.903 4.536 3.422 11.148-1.075 14.768s-11.307 2.879-15.211-1.657-3.423-11.148 1.074-14.769c4.498-3.62 11.308-2.878 15.212 1.658"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#selectivity_card_dark_svg__aL)",
    d: "M525.67 237.407c3.903 4.536 3.422 11.148-1.075 14.768s-11.307 2.879-15.211-1.657-3.423-11.148 1.074-14.769c4.498-3.62 11.308-2.878 15.212 1.658"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.556,
    cy: 11.978,
    fill: "#BABABA",
    rx: 11.556,
    ry: 11.978,
    transform: "matrix(.77894 -.6271 .6523 .75796 486.815 241.273)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.556,
    cy: 11.978,
    fill: "url(#selectivity_card_dark_svg__aM)",
    rx: 11.556,
    ry: 11.978,
    transform: "matrix(.77894 -.6271 .6523 .75796 486.815 241.273)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeWidth: 3,
    d: "M193.912 172.5v23.969a6 6 0 0 0 6 6h337.774a6 6 0 0 1 6 6v14.373c0 1.657 1.341 3 2.998 3h7.874",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__aN)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 207.954,
    cy: 230.651,
    fill: "#fff",
    rx: 14.892,
    ry: 42.276
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__aO)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#selectivity_card_dark_svg__aP)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 145,
    y: 104.055,
    fill: "#FF000F",
    rx: 12
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__aQ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2A2A2A",
    d: "M154.245 107.555h5.836l-3.932 7.181 6.601-2.629-7.677 14.879 2.876-9.726-5.856 2.463z"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__aR)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#selectivity_card_dark_svg__aS)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 82,
    y: 11,
    fill: "#00DD16",
    rx: 12
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__aT)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2A2A2A",
    d: "M91.245 14.5h5.836l-3.932 7.18 6.601-2.627-7.677 14.879 2.876-9.727-5.856 2.463z"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__aU)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#selectivity_card_dark_svg__aV)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 24,
    y: 104,
    fill: "#00DD16",
    rx: 12
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__aW)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2A2A2A",
    d: "M33.245 107.5h5.836l-3.932 7.181 6.601-2.628-7.677 14.879 2.876-9.726-5.856 2.462z"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__aX)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#BABABA",
    strokeWidth: 3,
    d: "M71.5 172.5v24.625a6 6 0 0 1-6 6H25.965a6 6 0 0 1-6-5.999v-12.399a3 3 0 0 1 3-2.999h6.52"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "m136.659 252.426 14.253-2.504"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2A2A2A",
    d: "m38.203 268.517 52.182-8.494"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BABABA",
    d: "M257.836 243.75v10.707h38.359"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__aY)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M397.181 255.276c0 23.349-20.86 42.277-46.591 42.277S304 278.625 304 255.276C304 231.928 324.859 213 350.59 213s46.591 18.928 46.591 42.276"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__aZ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M50.473 105.852a2 2 0 0 1 2-2H91.41a2 2 0 0 1 2 2v64.636a2 2 0 0 1-2 2H52.473a2 2 0 0 1-2-2z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__ba)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M170.965 105.859a2 2 0 0 1 2-2h38.937a2 2 0 0 1 2 2v64.637a2 2 0 0 1-2 2h-38.937a2 2 0 0 1-2-2z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 42.937,
    height: 68.637,
    x: 170.965,
    y: 103.859,
    fill: "#666",
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__bb)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.299,
    height: 29.379,
    x: 173.826,
    y: 124.527,
    fill: "#666",
    rx: 0.5
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 176.675,
    cy: 128.052,
    r: 1.455,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.91,
    cy: 156.751,
    r: 1.455,
    fill: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__bc)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.561,
    height: 26.016,
    x: 178.959,
    y: 125.395,
    fill: "#666",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26.36,
    height: 25.816,
    x: 179.059,
    y: 125.495,
    stroke: "#666",
    strokeWidth: 0.2,
    rx: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FF000F",
    d: "M178.978 126.296a.3.3 0 0 1 .3-.3h25.759a.3.3 0 0 1 .3.3v2.504h-26.359z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.022,
    height: 14.253,
    x: 189.156,
    y: 131.035,
    fill: "#F9F9F9",
    rx: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EBEBEB",
    strokeWidth: 0.1,
    d: "M179.855 154.141v2.185m0 5.706v-5.706m12.501-2.185v7.891m12.745-7.891v2.185m0 5.706v-5.706m-25.246 0h25.246"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#787878",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    d: "M212.62 111.609v7.288h-10.788v-7.288zm-29.256 0v7.225h.5v-7.225h17.468v7.288h-28.996v-7.288z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EBEBEB",
    strokeWidth: 0.1,
    d: "M172.354 112.703h40.503m-40.503.849h40.503m-40.503.849h40.503m-40.503.85h40.503m-40.503.849h40.503m-40.503.849h40.503m-40.503.849h40.503"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__bd)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M171.239 162.277h42.663v.634h-42.663z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#F1F1F1",
    d: "m178.959 128.668 3.758-.006 3.759-.007M198.81 128.668h6.526999999999999"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FCDB2E",
    strokeWidth: 0.8,
    d: "M182.68 136.098h5.394"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00DD16",
    strokeWidth: 1.5,
    d: "M182.68 145.023h5.394"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.5,
    d: "M205.519 132.09h-2.083M178.978 132.137h3.112M205.519 145.02h-2.083M178.978 145.02h3.112"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M178.978 136.098h3.112M203.193 136.098h2.354"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FF000F",
    strokeWidth: 2,
    d: "M182.391 132.09h4.4M198.34 132.09h4.705"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00DD16",
    strokeWidth: 0.8,
    d: "M198.34 136.098h2.352l1.933.001"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00DD16",
    strokeWidth: 1.5,
    d: "M198.34 145.02h4.705"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__be)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.829,
    height: 6.011,
    x: 186.728,
    y: 140.086,
    fill: "#F9F9F9",
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    width: 8.055,
    height: 1.867,
    x: 188.639,
    y: 141.188,
    fill: "#2A2A2A",
    rx: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 42.937,
    height: 68.637,
    x: 50.473,
    y: 103.852,
    fill: "#666",
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__bf)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.299,
    height: 29.379,
    x: 53.334,
    y: 124.52,
    fill: "#666",
    rx: 0.5
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 56.183,
    cy: 128.044,
    r: 1.455,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.418,
    cy: 156.744,
    r: 1.455,
    fill: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__bg)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.561,
    height: 26.016,
    x: 58.467,
    y: 125.387,
    fill: "#666",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26.36,
    height: 25.816,
    x: 58.566,
    y: 125.487,
    stroke: "#666",
    strokeWidth: 0.2,
    rx: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FF000F",
    d: "M58.486 126.288a.3.3 0 0 1 .3-.3h25.759a.3.3 0 0 1 .3.3v2.504h-26.36z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.022,
    height: 14.253,
    x: 68.664,
    y: 131.027,
    fill: "#F9F9F9",
    rx: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EBEBEB",
    strokeWidth: 0.1,
    d: "M59.363 154.133v2.185m0 5.706v-5.706m12.501-2.185v7.891m12.745-7.891v2.185m0 5.706v-5.706m-25.246 0h25.246"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#787878",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    d: "M92.128 111.602v7.288H81.34v-7.288zm-29.256 0v7.224h.5v-7.224H80.84v7.288H51.844v-7.288z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EBEBEB",
    strokeWidth: 0.1,
    d: "M51.58 112.695h40.503m-40.502.849h40.502m-40.502.85h40.502m-40.502.849h40.502m-40.502.849h40.502m-40.502.849h40.502m-40.502.849h40.502"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__bh)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M50.746 162.27h42.663v.634H50.746z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#F1F1F1",
    d: "m58.467 128.66 3.758-.006 3.759-.007M78.318 128.66h6.526999999999999"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FCDB2E",
    strokeWidth: 0.8,
    d: "M62.188 136.09h5.394"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00DD16",
    strokeWidth: 1.5,
    d: "M62.188 145.016h5.394"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.5,
    d: "M85.027 132.082h-2.083M58.486 132.129h3.112M85.027 145.012h-2.083M58.486 145.012h3.112"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M58.486 136.09h3.112M82.7 136.09h2.355"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FF000F",
    strokeWidth: 2,
    d: "M61.9 132.082h4.399M77.848 132.082h4.705"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00DD16",
    strokeWidth: 0.8,
    d: "M77.848 136.09H80.2l1.933.001"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00DD16",
    strokeWidth: 1.5,
    d: "M77.848 145.012h4.705"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__bi)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.829,
    height: 5.762,
    x: 66.236,
    y: 127.391,
    fill: "#F9F9F9",
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    width: 8.055,
    height: 1.531,
    x: 68.147,
    y: 128.512,
    fill: "#2A2A2A",
    rx: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__bj)",
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 278.59,
    cy: 235.901,
    fill: "#ACACAC",
    rx: 46.59,
    ry: 42.276
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__bk)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 207.954,
    cy: 235.276,
    fill: "#ACACAC",
    rx: 14.892,
    ry: 42.276
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__bl)",
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ACACAC",
    d: "M384.181 239.995c0 23.349-20.86 42.277-46.591 42.277S291 263.344 291 239.995c0-23.348 20.859-42.276 46.59-42.276s46.591 18.928 46.591 42.276"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__bm)",
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ACACAC",
    d: "M470 225.5c0 8.56-20.819 15.5-46.5 15.5s-46.5-6.94-46.5-15.5 20.819-15.5 46.5-15.5 46.5 6.94 46.5 15.5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#selectivity_card_dark_svg__bn)",
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ACACAC",
    d: "M546 228.5c0 11.874-20.819 21.5-46.5 21.5s-46.5-9.626-46.5-21.5 20.819-21.5 46.5-21.5 46.5 9.626 46.5 21.5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__b",
    width: 452.169,
    height: 383.24,
    x: 263.554,
    y: -6.044,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4225_272725",
    stdDeviation: 42.35
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__c",
    width: 108.901,
    height: 106.655,
    x: 512.088,
    y: 36.372,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4225_272725",
    stdDeviation: 16.15
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__d",
    width: 83.741,
    height: 83.471,
    x: 522.858,
    y: 45.27,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4225_272725",
    stdDeviation: 12.65
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__e",
    width: 19.59,
    height: 12.855,
    x: 551.939,
    y: 90.527,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4225_272725",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__f",
    width: 18.977,
    height: 15.344,
    x: 548.257,
    y: 87.164,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4225_272725",
    stdDeviation: 1.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__g",
    width: 11.847,
    height: 11.836,
    x: 554.255,
    y: 92.559,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4225_272725",
    stdDeviation: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__h",
    width: 8.885,
    height: 8.871,
    x: 548.159,
    y: 84.824,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4225_272725",
    stdDeviation: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__i",
    width: 4.766,
    height: 4.752,
    x: 556.445,
    y: 88.126,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4225_272725",
    stdDeviation: 0.4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__j",
    width: 4.766,
    height: 4.752,
    x: 557.753,
    y: 77.665,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4225_272725",
    stdDeviation: 0.4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__k",
    width: 9.166,
    height: 9.152,
    x: 557.156,
    y: 75.367,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4225_272725",
    stdDeviation: 1.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__l",
    width: 4.366,
    height: 4.352,
    x: 559.078,
    y: 75.623,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4225_272725",
    stdDeviation: 0.3
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__m",
    width: 19.559,
    height: 20.237,
    x: 553.412,
    y: 83.7,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4225_272725",
    stdDeviation: 3.65
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__n",
    width: 11.845,
    height: 12.193,
    x: 557.133,
    y: 81.21,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4225_272725",
    stdDeviation: 0.85
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__o",
    width: 6.137,
    height: 6.507,
    x: 562.244,
    y: 93.573,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4225_272725",
    stdDeviation: 0.45
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__p",
    width: 5.139,
    height: 5.421,
    x: 566.712,
    y: 78.245,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4225_272725",
    stdDeviation: 0.45
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__q",
    width: 26.776,
    height: 20.234,
    x: 549.521,
    y: 79.438,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4225_272725",
    stdDeviation: 0.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__r",
    width: 7.711,
    height: 8.027,
    x: 564.335,
    y: 80.441,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4225_272725",
    stdDeviation: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__s",
    width: 4.339,
    height: 4.621,
    x: 549.574,
    y: 79.633,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4225_272725",
    stdDeviation: 0.25
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__t",
    width: 16.161,
    height: 18.492,
    x: 563.656,
    y: 73.613,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4225_272725",
    stdDeviation: 0.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__J",
    width: 314.554,
    height: 112.678,
    x: -5.873,
    y: -3.019,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4225_272725",
    stdDeviation: 2.9
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__K",
    width: 313.754,
    height: 111.878,
    x: -5.576,
    y: 1.819,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4225_272725",
    stdDeviation: 2.7
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__L",
    width: 72.146,
    height: 24.423,
    x: 127.098,
    y: 89.136,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4225_272725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__M",
    width: 72.146,
    height: 24.423,
    x: 64.947,
    y: 89.136,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4225_272725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__N",
    width: 61.591,
    height: 91.634,
    x: 101.109,
    y: 9.3,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4225_272725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__O",
    width: 51.601,
    height: 42.344,
    x: 106.153,
    y: 31.16,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4225_272725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__P",
    width: 39.048,
    height: 38.41,
    x: 112.153,
    y: 36.176,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4225_272725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__Q",
    width: 70.472,
    height: 21.342,
    x: 96.828,
    y: 72.989,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4225_272725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__R",
    width: 21.828,
    height: 15.102,
    x: 121.235,
    y: 38.516,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4225_272725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__S",
    width: 125.296,
    height: 85.685,
    x: 548.745,
    y: 196.894,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4225_272725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__T",
    width: 115.557,
    height: 54.748,
    x: 552.011,
    y: 153.784,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4225_272725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__U",
    width: 12.727,
    height: 20.383,
    x: 583.861,
    y: 214.777,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4225_272725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__V",
    width: 5.37,
    height: 15.793,
    x: 655.859,
    y: 216.383,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4225_272725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__W",
    width: 7.854,
    height: 15.391,
    x: 659.29,
    y: 216.633,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4225_272725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__X",
    width: 19.425,
    height: 28.777,
    x: 567.073,
    y: 221.332,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4225_272725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__Y",
    width: 19.425,
    height: 28.777,
    x: 562.394,
    y: 221.332,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4225_272725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__Z",
    width: 18.951,
    height: 25.52,
    x: 553.656,
    y: 221.754,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4225_272725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__aa",
    width: 8.623,
    height: 20.969,
    x: 558.141,
    y: 225.051,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4225_272725"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__ab",
    width: 0.471,
    height: 5.371,
    x: 565.031,
    y: 226.746,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4225_272725"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__ac",
    width: 0.471,
    height: 5.371,
    x: 564.074,
    y: 225.77,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4225_272725"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__ad",
    width: 0.471,
    height: 5.371,
    x: 563.137,
    y: 225.172,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4225_272725"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__ae",
    width: 0.471,
    height: 5.371,
    x: 562.126,
    y: 225.051,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4225_272725"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__af",
    width: 0.471,
    height: 5.371,
    x: 561.116,
    y: 225.445,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4225_272725"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__ag",
    width: 0.471,
    height: 5.371,
    x: 560.215,
    y: 226.262,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4225_272725"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__ah",
    width: 0.471,
    height: 5.371,
    x: 559.529,
    y: 227.176,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4225_272725"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__ai",
    width: 0.471,
    height: 5.371,
    x: 558.826,
    y: 228.438,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4225_272725"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__aj",
    width: 0.471,
    height: 5.371,
    x: 558.339,
    y: 229.812,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4225_272725"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__ak",
    width: 0.471,
    height: 5.371,
    x: 558.141,
    y: 231.633,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4225_272725"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__al",
    width: 0.471,
    height: 5.371,
    x: 558.141,
    y: 233.324,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4225_272725"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__am",
    width: 0.471,
    height: 5.371,
    x: 558.394,
    y: 235.184,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4225_272725"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__an",
    width: 0.471,
    height: 5.371,
    x: 558.736,
    y: 236.754,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4225_272725"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__ao",
    width: 0.471,
    height: 5.371,
    x: 559.404,
    y: 238.25,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4225_272725"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__ap",
    width: 0.471,
    height: 5.371,
    x: 560.287,
    y: 239.258,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4225_272725"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__aq",
    width: 0.471,
    height: 5.371,
    x: 561.026,
    y: 239.941,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4225_272725"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__ar",
    width: 0.471,
    height: 5.371,
    x: 561.928,
    y: 240.504,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4225_272725"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__as",
    width: 0.471,
    height: 5.371,
    x: 562.885,
    y: 240.648,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4225_272725"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__at",
    width: 0.471,
    height: 5.371,
    x: 563.84,
    y: 240.609,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4225_272725"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__au",
    width: 0.471,
    height: 5.371,
    x: 564.688,
    y: 239.961,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4225_272725"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__av",
    width: 0.471,
    height: 5.371,
    x: 565.608,
    y: 239.098,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4225_272725"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__aw",
    width: 0.471,
    height: 5.371,
    x: 566.293,
    y: 237.945,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4225_272725"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__ax",
    width: 6.806,
    height: 12.316,
    x: 559.402,
    y: 227.777,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4225_272725"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__ay",
    width: 93.374,
    height: 20.766,
    x: 573.497,
    y: 243.234,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4225_272725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__aA",
    width: 12.992,
    height: 23.297,
    x: 608.607,
    y: 200.258,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4225_272725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__aB",
    width: 12.992,
    height: 21.305,
    x: 644.459,
    y: 200.965,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4225_272725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__aD",
    width: 90.875,
    height: 17.809,
    x: 577.419,
    y: 240.062,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4225_272725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__aF",
    width: 12.872,
    height: 15.793,
    x: 587.371,
    y: 247.047,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4225_272725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__aG",
    width: 3.028,
    height: 6.035,
    x: 592.148,
    y: 251.395,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4225_272725"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__aN",
    width: 160.784,
    height: 215.555,
    x: 127.562,
    y: 122.875,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4225_272725",
    stdDeviation: 32.75
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__aO",
    width: 55.8,
    height: 55.8,
    x: 129.1,
    y: 88.155,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.413846 0 0 0 0 0.0230772 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4225_272725",
    result: "effect2_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4225_272725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__aQ",
    width: 18.657,
    height: 27.434,
    x: 148.093,
    y: 103.555,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4225_272725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__aR",
    width: 55.8,
    height: 55.8,
    x: 66.1,
    y: -4.9,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.413846 0 0 0 0 0.0230772 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4225_272725",
    result: "effect2_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4225_272725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__aT",
    width: 18.657,
    height: 27.434,
    x: 85.093,
    y: 10.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4225_272725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__aU",
    width: 55.8,
    height: 55.8,
    x: 8.1,
    y: 88.1,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.413846 0 0 0 0 0.0230772 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4225_272725",
    result: "effect2_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4225_272725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__aW",
    width: 18.657,
    height: 27.434,
    x: 27.093,
    y: 103.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4225_272725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__aX",
    width: 65.934,
    height: 43.525,
    x: 12.765,
    y: 170.8,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4225_272725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__aY",
    width: 224.181,
    height: 215.555,
    x: 238.5,
    y: 147.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4225_272725",
    stdDeviation: 32.75
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__aZ",
    width: 54.337,
    height: 80.037,
    x: 44.773,
    y: 102.152,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4225_272725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__ba",
    width: 54.337,
    height: 80.037,
    x: 165.265,
    y: 102.159,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4225_272725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__bb",
    width: 45.299,
    height: 37.379,
    x: 169.826,
    y: 120.527,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4225_272725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__bc",
    width: 34.56,
    height: 34.016,
    x: 174.959,
    y: 125.395,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4225_272725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__bd",
    width: 63.263,
    height: 21.233,
    x: 160.939,
    y: 155.977,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4225_272725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__be",
    width: 19.829,
    height: 14.012,
    x: 182.728,
    y: 140.086,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4225_272725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__bf",
    width: 45.299,
    height: 37.379,
    x: 49.334,
    y: 120.52,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4225_272725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__bg",
    width: 34.56,
    height: 34.016,
    x: 54.467,
    y: 125.387,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4225_272725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__bh",
    width: 63.263,
    height: 21.233,
    x: 40.447,
    y: 155.97,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4225_272725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__bi",
    width: 19.829,
    height: 13.762,
    x: 62.236,
    y: 127.391,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4225_272725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4225_272725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__bj",
    width: 224.181,
    height: 215.555,
    x: 166.5,
    y: 128.125,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4225_272725",
    stdDeviation: 32.75
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__bk",
    width: 160.784,
    height: 215.555,
    x: 127.562,
    y: 127.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4225_272725",
    stdDeviation: 32.75
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__bl",
    width: 224.181,
    height: 215.555,
    x: 225.5,
    y: 132.219,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4225_272725",
    stdDeviation: 32.75
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__bm",
    width: 224,
    height: 162,
    x: 311.5,
    y: 144.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4225_272725",
    stdDeviation: 32.75
  })), /*#__PURE__*/React.createElement("filter", {
    id: "selectivity_card_dark_svg__bn",
    width: 224,
    height: 174,
    x: 387.5,
    y: 141.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4225_272725",
    stdDeviation: 32.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_dark_svg__u",
    x1: 10.773,
    x2: 10.773,
    y1: 0,
    y2: 21.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_dark_svg__v",
    x1: 10.773,
    x2: 10.773,
    y1: 0,
    y2: 21.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_dark_svg__w",
    x1: 10.773,
    x2: 10.773,
    y1: 0,
    y2: 21.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_dark_svg__x",
    x1: 10.773,
    x2: 10.773,
    y1: 0,
    y2: 21.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_dark_svg__y",
    x1: 10.773,
    x2: 10.773,
    y1: 0,
    y2: 21.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_dark_svg__z",
    x1: 9.819,
    x2: 9.819,
    y1: 0,
    y2: 20.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_dark_svg__A",
    x1: 8.772,
    x2: 8.772,
    y1: 0,
    y2: 18.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_dark_svg__B",
    x1: 11.556,
    x2: 11.556,
    y1: 0,
    y2: 23.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_dark_svg__C",
    x1: 11.556,
    x2: 11.556,
    y1: 0,
    y2: 23.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_dark_svg__D",
    x1: 11.556,
    x2: 11.556,
    y1: 0,
    y2: 23.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_dark_svg__E",
    x1: 8.076,
    x2: 8.076,
    y1: 0,
    y2: 16.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_dark_svg__F",
    x1: 8.076,
    x2: 8.076,
    y1: 0,
    y2: 16.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_dark_svg__G",
    x1: 12.892,
    x2: 12.892,
    y1: 0,
    y2: 26.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_dark_svg__H",
    x1: 10.867,
    x2: 10.867,
    y1: 0,
    y2: 22.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_dark_svg__I",
    x1: 18.473,
    x2: 18.473,
    y1: 0,
    y2: 38.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_dark_svg__az",
    x1: 579.836,
    x2: 583.406,
    y1: 258.241,
    y2: 252.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B8B8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_dark_svg__aE",
    x1: 585.993,
    x2: 588.038,
    y1: 253.475,
    y2: 238.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B8B8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_dark_svg__aH",
    x1: 9.312,
    x2: 9.312,
    y1: 0,
    y2: 19.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_dark_svg__aI",
    x1: 11.556,
    x2: 11.556,
    y1: 0,
    y2: 23.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_dark_svg__aJ",
    x1: 8.076,
    x2: 8.076,
    y1: 0,
    y2: 16.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_dark_svg__aK",
    x1: 18.973,
    x2: 18.973,
    y1: 0,
    y2: 39.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_dark_svg__aL",
    x1: 509.384,
    x2: 522.967,
    y1: 238.445,
    y2: 255.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectivity_card_dark_svg__aM",
    x1: 11.556,
    x2: 11.556,
    y1: 0,
    y2: 23.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "selectivity_card_dark_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 700,
    height: 301,
    fill: "#fff",
    rx: 8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "selectivity_card_dark_svg__aC"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M601.06 218.105h7.225v3.612h-7.225z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "selectivity_card_dark_svg__aP"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 145,
    y: 104.055,
    fill: "#fff",
    rx: 12
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "selectivity_card_dark_svg__aS"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 82,
    y: 11,
    fill: "#fff",
    rx: 12
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "selectivity_card_dark_svg__aV"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 24,
    y: 104,
    fill: "#fff",
    rx: 12
  })))));
};
export default SvgSelectivityCardDark;